export const SET_PAGINATION_QUESTION = 'SET_PAGINATION_QUESTION';

export function setPaginationQuestionAction(pagination) {
    return {
        type: SET_PAGINATION_QUESTION,
        payload: pagination
    };
}

